const mps = {
  el: $('.mps'),
  trigger: $('.js-mobile-popup-selection'),
  closeEls: $('.mps__bg, .mps__close'),
  init() {
    this.openEvent();
    this.closeEvent();
  },
  openEvent() {
    const self = this;
    this.trigger.on('click', function () {
      const thisTrigger = $(this);
      const thisId = thisTrigger.data('target-id');
      if ($(window).width() < mobileBp) {
        self.open(typeof thisId !== 'undefined' ? thisId : '');
      }
    });
  },
  closeEvent() {
    this.closeEls.on('click', () => {
      this.close();
    });
  },
  open(el) {
    if (el.length) {
      $(el).addClass('active');
    } else {
      this.el.addClass('active');
    }
    bodyScrollLock.disableBodyScroll();
  },
  close() {
    this.el.removeClass('active');
    bodyScrollLock.enableBodyScroll();
  }
};

$(document).ready(() => {
  if (mps.trigger.length > 0 && mps.el.length > 0) {
    mps.init();
  }
});